import { StyleSheet, Dimensions, Platform } from 'react-native'
import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

import images from '../../Themes/Images'

const { width: SCREEN_WIDTH } = Dimensions.get('window')

const styles = StyleSheet.create({
  screenWrapper: {
    flex: 1,
  },
  row: {
    flexDirection: 'row',
    minWidth: 100,
    justifyContent: 'flex-end',
  },
  webView: {
    marginHorizontal: 8,
  },
  scrollContainer: (bottomInset = 0) => {
    return {
      flexGrow: 1,
      paddingBottom: bottomInset + 250,
    }
  },
  scrollContainerWithSpace: (bottomInset = 0) => {
    return {
      flexGrow: 1,
      paddingBottom: bottomInset + 120,
      justifyContent: 'space-between',
    }
  },
  timelineContainer: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    padding: 16
  }),
  timelineIconContainer: {
    marginBottom: 4,
  },
  timelineItemTitle: {
    padding: 0,
    fontSize: 16,
  },
  timelineActiveItemTitle: theme => ({
    color: theme.colors.textColor,
  }),
  viewPager: {
    flex: 1,
    overflow: 'scroll'
  },
  sectionTitle: {
    margin: 16,
    marginTop: 32,
  },
  sectionSubTitle: {
    marginHorizontal: 16,
  },
  firstCardStyle: {
    marginHorizontal: 16,
    marginTop: 32,
    marginBottom: 0,
    padding: 0,
  },
  cardStyle: {
    margin: 16,
    padding: 0,
  },
  cardContentContainer: {
    paddingVertical: 0,
  },
  mySelection: {
    marginTop: 0,
  },
  collapsedContent: {
    backgroundColor: Colors.whiteSmoke,
    paddingBottom: 16,
  },
  extraListContainer: {
    margin: 16,
    marginRight: 0,
  },
  options: {
    marginHorizontal: 12,
    marginBottom: 16,
  },
  firstButton: {
    margin: 16,
    marginTop: 32,
    marginBottom: 0,
  },
  lastButton: {
    // marginHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 16,
  },
  button: {
    marginTop: 20,
    ...Platform.select({
      android: {
        marginBottom: 16
      }
    }),
  },
  cancelButton: {
    margin: 16,
  },
  collapsedContent2: {
    paddingHorizontal: 16,
    backgroundColor: Colors.white,
  },
  titleStyle: {
    ...Fonts.type.bold,
  },
  titleStyle2: {
    fontSize: 14,
  },
  descStyles2: {
    fontSize: 18,
    ...Fonts.type.bold,
  },
  toggleAllContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 10,
    marginRight: 16,
    paddingTop: 32,
    paddingBottom: 0,
    flexShrink: 1,
  },
  viewTermsLink: {
    flexGrow: 1,
    flexShrink: 1,
  },
  viewTermsText: {
    flexShrink: 1,
    textDecorationLine: 'underline',
    flexWrap: 'wrap',
  },
  full: {
    flex: 1,
  },
  fill: {
    flexGrow: 1,
    flexShrink: 1,
  },
  modalHeaderContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginHorizontal: 16,
    marginTop: 24,
    marginBottom: 16,
  },
  inputContainer: {
    minHeight: 50,
  },
  extraTitleStyle: {
    marginTop: 2,
    fontSize: 14,
  },
  checkBoxStyle: {
    marginTop: 12,
    marginRight: 12,
    marginLeft: 4,
  },
  extraIconStyle: {
    margin: 4,
    marginVertical: 8,
    tintColor: Colors.mustardGreen,
    width: 16,
    height: 16,
  },
  termsRowStyle: {
    borderTopColor: Colors.veryLightPinkTwo,
    borderTopWidth: 1,
    borderStyle: 'solid',
    paddingVertical: 16,
  },
  bottomText: {
    margin: 16,
  },
  secondaryButton: {
    marginTop: 16,
  },
  textSpacing: {
    marginHorizontal: 16,
    marginVertical: 8,
  },
  horizontalSpacing: {
    marginHorizontal: 16,
  },
  cardContentContaoner3: {
    padding: 8,
    marginBottom: 18,
    overflow: 'hidden',
  },
  radioGroup: {
    marginTop: 16,
  },
  summary: (bottom = 0) => {
    return {
      marginTop: 32,
      paddingBottom: bottom,
      backgroundColor: Colors.white,
    }
  },
  separator: {
    margin: 16,
    backgroundColor: Colors.veryLightPinkTwo,
  },
  sumaryDetailsrowContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  iconHIFI: {
    width: 42,
    height: 42,
  },
  verificationCodeSentTitle: {
    fontSize: 14,
    marginTop: 12,
  },
  verificationCodeSentContainer: {
    margin: 16,
    marginBottom: 24,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: Colors.veryLightPinkTwo,
    borderStyle: 'solid',
  },
  touchableText: {
    textDecorationLine: 'underline',
  },
  icon: {
    resizeMode: 'contain',
  },
  verificationRowIcon: {
    width: 32,
    height: 32,
    resizeMode: 'contain',
    tintColor: Colors.thinDark,
  },
  deleteIcon: {
    tintColor: Colors.red,
  },
  verificationRowText: {
    fontSize: 18,
    marginTop: 20,
  },
  buttonInCard: {
    margin: 8,
    marginTop: 16,
  },
  capturedImageContainer: {
    minWidth: SCREEN_WIDTH - 64,
    minHeight: ((SCREEN_WIDTH - 32) / 1.582) - 16,
    borderRadius: 10,
    overflow: 'hidden',
    marginTop: 16,
  },
  capturedImage: {
    resizeMode: 'contain',
  },
  scannedImageText: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  cameraContainer: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  camera: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  overlayMask: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: Colors.blackRGBA(0.75),
  },
  overlayMaskOutline: {
    position: 'absolute',
    left: 16,
    borderRadius: 10,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: Colors.white,
  },
  cameraControlContainer: {
    width: '100%',
    minHeight: 100,
    backgroundColor: Colors.white,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    marginTop: -10,
    position: 'absolute',
  },
  cameraControlHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 32,
    marginHorizontal: 16,
    marginBottom: 8,
  },
  takePictureOuter: {
    width: 64,
    height: 64,
    backgroundColor: Colors.lightGrayTwo,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 32,
  },
  takePictureInner: {
    width: 50,
    height: 50,
    backgroundColor: Colors.thinDark,
    borderRadius: 25,
  },
  modal: (theme, insets) => ({
    marginBottom: 0,
    backgroundColor: theme.colors.backgroundColor,
    paddingBottom: insets.bottom
  }),
  termsModal: {
    height: '80%',
  },
  takePictureContainer: {
    margin: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },

  // Input styles
  inputText: {
    fontFamily: Fonts.type.VFFont,
  },

  // Modal non scrollable content
  modalContentContainerWraper: {
    flexGrow: 1,
    paddingHorizontal: 16,
    paddingVertical: 32,
  },
  modalContentWraper: {
    flexGrow: 1,
    marginTop: 64,
    justifyContent: 'center',
    alignItems: 'center',

  },
  verticalSpacing: {
    marginTop: 35,
    marginBottom: 16,
  },
  modalContentWraper2: {
    flexGrow: 1,
    marginBottom: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },

  offerDetailsContainer: {
    marginHorizontal: 16,
  },
  offerDetailsContent: {
    marginTop: 32,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  iosCheckBoxStyle: {
    height: 20,
    width: 20,
    marginVertical: 18,
    marginHorizontal: 16,
  },
  lottieWrapper: {
    height: '100%',
    paddingHorizontal: 16,
    paddingVertical: 32,
    marginBottom: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
  lottie: {
    width: 150,
    height: 150,
    marginLeft: 0,
    alignSelf: 'center',
  },


  //aaaa
  subHeaderContainer: {
    paddingHorizontal: 8,
  },
  titleText: {
    fontSize: Fonts.size.h4,
  },
  subtitleText: {
    fontSize: Fonts.size.h5,
  },
  subHeaderAfterSubTitleStyle: {
    marginBottom: 3,
  },
  descContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginVertical: 5,
  },
  descSubTitleContainer: (showSubHeaderDesc) => ({
    flexDirection: 'row',
    justifyContent: showSubHeaderDesc ? 'space-between' : 'flex-end',
    alignItems: 'center',
    marginTop: 5,
  }),
  detailsBtn: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  detailsBtnIcon: {
    marginLeft: 5,
    tintColor: Colors.vfRed,
  },
  offerPriceContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  offerPrice: {
    fontFamily: Fonts.type.bold.fontFamily,
    fontWeight: Fonts.type.bold.fontWeight,
    fontSize: Fonts.size.regular,
  },
  offerPeriod: {
    fontFamily: Fonts.type.VFFont,
    color: Colors.dark_grey,
    fontSize: Fonts.size.regular,
    marginBottom: -3,
  },
  offerOriginalPrice: {
    fontFamily: Fonts.type.VFFont,
    color: Colors.light_grey,
    fontSize: Fonts.size.regular,
    textDecorationLine: 'line-through',
  },
  offerValidity: {
    fontFamily: Fonts.type.VFFont,
    color: Colors.light_grey,
    fontSize: Fonts.size.regular,
  },
  viewDetailText: {
    color: Colors.vfRed,
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.regularSmall,
  },
  subHeaderDesc: {
    fontSize: Fonts.size.h5,
  },
  //
  bundleListContainerStyle: {
    marginTop: 0,
    paddingBottom: 150,
  },
  // ID
  idContainer: {
    paddingBottom: 20,
    paddingHorizontal: 16,
    //minHeight: 280,
  },
  idCardStyle: {
    marginTop: 20,
  },
  idTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  idText: {
    marginLeft: 10,
  },
  stepTitle: {
    fontSize: Fonts.size.h4,
    marginVertical: 15,
    fontFamily: Fonts.type.bold.fontFamily,
    fontWeight: Fonts.type.bold.fontWeight,
  },
  stepDesc: theme => ({
    fontSize: Fonts.size.regular,
    color: theme.colors.textColorTwo,
    fontFamily: Fonts.type.VFFont,
    lineHeight: 25,
    marginBottom: 5,
  }),
  titleOfferStyle: theme => ({
    color: theme.colors.textColorTwo,
    fontSize: Fonts.size.h5,
    fontFamily: Fonts.type.bold.fontFamily,
    fontWeight: Fonts.type.bold.fontWeight,
  }),
  line: theme => ({
    marginTop: 20,
    backgroundColor: theme.colors.borderColorThree,
  }),
  modemLine: {
    marginVertical: 12,
    backgroundColor: Colors.lightGrey,
  },
  explanationText: {
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.regularSmall,
    marginTop: 20,
    lineHeight: 20,
  },
  btnStyle: {
    marginTop: 20,
    marginBottom: 0
  },
  idImage: {
    // width: '100%',
    height: 200,
    resizeMode: 'cover',
    marginTop: 18,
  },

  offerCardStyle: {
    marginHorizontal: 0,
    marginTop: 20,
  },
  descOfferContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    alignItems: 'center',
  },
  itemContentContainer: {
    backgroundColor: Colors.whiteSmoke,
    marginBottom: 5,
  },
  rowContainer: {
    padding: 20,
  },
  rowItem: {
    flexDirection: 'row',
    paddingVertical: 10,
  },
  itemRowTitle: {
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.regular,
    color: Colors.dark_grey,
    marginLeft: 16,
  },
  offerBottomContent: {
    backgroundColor: Colors.white,
    padding: 16,
  },
  descOfferStyle: {
    fontSize: Fonts.size.regular,
    fontFamily: Fonts.type.VFFont,
  },
  offerIconsContainer: {
    flexDirection: 'row',
    marginVertical: 12,
  },
  itemIcon: {
    marginRight: 20,
  },
  offerBtnContainer: {
    borderTopWidth: 1,
    borderTopColor: Colors.lightGrey,
    paddingHorizontal: 16,
    backgroundColor: Colors.white,
    paddingBottom: 20,
  },
  detailContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    alignItems: 'center',
  },
  periodTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  costDetailsText: {
    marginRight: 8,
    fontWeight: Fonts.type.bold.fontWeight,
  },
  costText: {
    ...Fonts.type.bold,
    fontSize: 16,

  },
  summaryContainer: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    // paddingHorizontal: 15,
    marginTop: 60,
    paddingBottom: 20,
    marginVertical: 30,
    borderRadius: 6
  }),
  stepTitleContainer: {
    paddingHorizontal: 15,
  },
  timeSlots: {
    paddingHorizontal: 13,
  },
  modemSection: {
    paddingHorizontal: 13,
    marginTop: 16,
  },
  reallocationInfo: {
    marginTop: 24,
    marginBottom: 8,
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 14,
  },
  modemPriceInfo: {
    marginTop: 30,
    marginBottom: 8,
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 14,
    marginHorizontal: 15,
  },
  spaceBetweenItems: {
    justifyContent: 'space-between',
  },
  inlineItems: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  leftDataModem: {
    flexGrow: 1,
    marginLeft: 20,
  },
  verticalSpacingModem: {
    marginVertical: 16,
  },
  costDetailsTitle: {
    color: Colors.dark_grey,
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.regularSmall,
    fontWeight: 'bold',
  },
  installationContainer: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    padding: 16,
  }),
  // Summary
  summaryScrollWrapper: theme => ({
    backgroundColor: theme.colors.backgroundColorTwo,
  }),
  summaryContainerWrapper: theme => ({
    backgroundColor: theme.colors.backgroundColorTwo,
  }),
  summarySelectedContainer: {
    paddingTop: 0,
    marginTop: 0,
    paddingBottom: 16,
  },
  rowLine: theme => ({
    margin: 16,
    backgroundColor: theme.colors.borderColorThree,
  }),
  summaryBreakdownContainer: theme => ({
    padding: 16,
    backgroundColor: theme.colors.backgroundColorTwo,
  }),
  horizontalSpace: {
    paddingHorizontal: 16,
  },
  linkContainer: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    // paddingHorizontal: 15,
    marginTop: 20,
  }),
  linkTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  linkText: {
    fontSize: 14,
    fontFamily: Fonts.type.VodafoneLt,
  },
  underLineText: {
    textDecorationLine: 'underline',
    marginLeft: 2,
  },
  //Id 
  idStepDesc: theme => ({
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 24,
    color: theme.colors.textColorTwo,
    marginVertical: 22
  }),
  idStepSubDesc: theme => ({
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 16,
    color: theme.colors.textColorTwo,
    marginBottom: 26,
    lineHeight: 20
  }),
  idErrorContainer: {
    alignItems: 'center',
    marginTop: 20,
  },
  textContentLoader: {
    marginLeft: 16,
    marginTop: 20
  },
  errorScreenBackground: theme => ({
    height: 'auto',
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  errorIconStyle: {
    marginTop: 0,
  },
  errorTextStyle: {
    marginTop: -60,
  },
})

const extraIcon = images.tickConfirm

const checkBoxTintcolors = {
  true: Colors.ocean,
  false: Colors.veryLightPink,
}

const timelineTitleProps = {
  numberOfLines: 1,
  ellipsizeMode: 'clip',
}

export default styles
export { timelineTitleProps, checkBoxTintcolors, extraIcon }
